import React, { useEffect, useState } from "react";
import BlogPage from "../../components/old/PrismicArticles/blog_page";
import NewBlogPage from "../../components/newBlogPage/new_blog_page";
import NewBlogPageFr from "../../components/newBlogPage/new_blog_page_fr";
import Navbar from "../../sections/Navbar/Navbar";
import Footer from "../../sections/Footer";
import Seo from "../../utils/seo";
import { graphql } from "gatsby";
import BlogPageFr from "../../components/old/PrismicArticles/blog_page_fr";
import NavbarFr from "../../sections/Navbar/NavbarFr";
import FooterFr from "../../sections/FooterFr";
import ProgressBar from "../../components/ProgressBar";

const BlogPost = ({ data }) => {
  const blog = data.newBlog || data.oldBlog;

  const language = blog?.lang || "en-us";
  return (
    <>
      {language === "fr-fr" ? (
        <>
          <div className="fixed w-full z-10">
            <NavbarFr />
            <ProgressBar
              height="5"
              bgcolor="#fd0054"
              duration="0.1"
              containerBgColor="#fecbc4"
            />
          </div>
          <Seo
            title={blog?.dataRaw?.seo_title?.[0]?.text || "Coachello"}
            description={
              blog?.dataRaw?.seo_description?.[0]?.text || "Coachello"
            }
            canonical={`https://coachello.ai${blog?.url}`}
          />
          {/* <BlogPageFr blog={blog} /> */}
          <NewBlogPageFr blog={blog} />
          <FooterFr />
        </>
      ) : (
        <>
          <div className="fixed w-full z-10">
            <Navbar />
            <ProgressBar
              height="5"
              bgcolor="#fd0054"
              duration="0.1"
              containerBgColor="#fecbc4"
            />
          </div>

          <Seo
            title={blog?.dataRaw?.seo_title?.[0]?.text || "Coachello"}
            description={
              blog?.dataRaw?.seo_description?.[0]?.text || "Coachello"
            }
            canonical={`https://coachello.ai${blog?.url}`}
          />
          {/* <BlogPage blog={blog} /> */}
          <NewBlogPage blog={blog} />
          <Footer />
        </>
      )}
    </>
  );
};

export default BlogPost;

export const query = graphql`
  query BlogPost($id: String) {
    oldBlog: prismicOldBlogPage(id: { eq: $id }) {
      id
      lang
      url
      uid
      dataRaw
      data {
        image {
          url(imgixParams: { width: 1920, q: 100 })
        }
      }
    }
    newBlog: prismicNewBlogPage(id: { eq: $id }) {
      id
      lang
      url
      uid
      dataRaw
      data {
        image {
          url(imgixParams: { width: 1920, q: 100 })
        }
      }
    }
  }
`;

//   query BlogPost($id: String) {
//     prismicBlogPage(id: { eq: $id }) {
//       uid
//       id
//       url
//       lang
//       dataRaw
//       data {
//         image {
//           url(imgixParams: { width: 1920, q: 100 })
//         }
//       }
//     }
//   }
